import styles from 'style-guide/TypographyGuide.module.css';

interface ButtonTextProps {
  text: string;
  textColor?: string;
}

export const ButtonText = ({ text, textColor }: ButtonTextProps) => {
  return (
    <h4 className={`${styles.button_one}`} style={{ color: textColor }}>
      {text}
    </h4>
  );
};
